import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import * as GQL from "src/types/graphql";
import { HasuraRole } from "src/types/hasuraRole";
import useRequiredHasuraRoles from "./useRequiredHasuraRoles";

export function useSubStatusTransition() {
  const flags = useFlags([
    "not_considered_lock",
    "offer_from_waitlist_only",
    "clear_status_lock",
  ]);
  const isSchoolOrDistrictAdmin = useRequiredHasuraRoles([
    HasuraRole.SCHOOL_ADMIN,
    HasuraRole.DISTRICT_ADMIN,
  ]);

  const isSubStatusTransitionAllowed = (
    fromSubStatus: string | null,
    toSubStatus: string | null
  ) => {
    if (isSchoolOrDistrictAdmin) {
      if (flags["not_considered_lock"].enabled) {
        if (
          toSubStatus === GQL.form_school_rank_status_enum.NotConsidered ||
          fromSubStatus === GQL.form_school_rank_status_enum.NotConsidered
        ) {
          return false;
        }
      }
      if (flags["offer_from_waitlist_only"].enabled) {
        if (
          toSubStatus === GQL.offer_status_enum.Offered &&
          fromSubStatus !== GQL.waitlist_status_enum.Waitlisted
        ) {
          return false;
        }
      }
      if (flags["clear_status_lock"].enabled) {
        if (toSubStatus === null) {
          return false;
        }
      }
    }
    return true;
  };

  return {
    isSubStatusTransitionAllowed,
  };
}
